import React from 'react';
import logo from '../assests/img/lab-logo.png';
import mobilelogo from '../assests/img/logo-mobile.jpg';
import shortlogo from '../assests/img/ad-circle.png';
import Topmenuleft from './Topmenuleft';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Mobilemenu from './Mobilemenu';
import { IoMdClose } from "react-icons/io";
import SearchBar from './Searchbar';


function Header() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();
  const isContactActive = location.pathname === '/contact';

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isDarkMode]);


  return (
    <>
      <header>
        <div className='top-bar'>
            <div className='container'>
             <div className='row'>
          <div className='col-md-6'>
              <div className='top-social'>

                <ul className='flex'>
                  <li> <a href="https://www.facebook.com/labway.scientific.7" target="_blank"><FaFacebook /></a></li>
                               {/* <li>  <a href="#"><FaYoutube /></a></li>
                               <li>  <a href="#"><FaInstagram /></a></li> */}
                </ul>

            </div>
          </div>

          <div className='col-md-6'>
              <div className='top-contact'>
          <ul className='flex'>                  
                   <li>  <a href="mailto:info@labwayscientific.com">
                            info@labwayscientific.com
                          </a>
                          </li>

                            <li><FaWhatsapp />  <a href="tel:+91-92066-91066">
                           +91-92066-91066
                          </a>
                          </li>
                </ul>

          </div>
          </div>
           
        </div>
        </div>

        </div>
      
        
      <div className='container'>
       
        <div className='row'>
          <div className='col-md-2 upcoming-event-box'>
         

             <Link to='/' className='logo-img-box'>
            <img className='main-logo' src={logo}/>
            {/* <img className='c-logo' src={shortlogo}/> */}
            </Link>

              <button className='menu-toggle-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
           <span className="menu-title">Menu</span>
           </button>

            {/* <Link to='/' className='logo-img-box-mobile'>
            <img className='main-logo-mobile' src={mobilelogo}/>
            </Link>
              */}
             
                 
          </div>
          <div className='col-md-7 main-logo-box search-col'>
         

         

           <div className="header-element search-wrap">
                               <SearchBar />
                              </div>

          </div>


          <div className='col-md-3 download-box-header'>
      <p className='making-text'>Making Science easier</p>
        
       
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
      <Topmenuleft/>     
          </div>
        </div>
      </div>

      <div className='mobile-menu'>
      <button className='menu-close-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
      <IoMdClose />
          </button>
        <Mobilemenu/>
      </div>
    
      </header>
     
      </>
  )

}

export default Header;
